import { render } from "./CustomDateInput.vue?vue&type=template&id=2d5b0fc2&scoped=true"
import script from "./CustomDateInput.vue?vue&type=script&lang=js"
export * from "./CustomDateInput.vue?vue&type=script&lang=js"

import "./CustomDateInput.vue?vue&type=style&index=0&id=2d5b0fc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5b0fc2"]])

export default __exports__